import React, { useState } from "react"
import { observer } from "mobx-react-lite"
import styled, { useTheme } from '~/ui/styled'
import useNavigation from "~hooks/useNavigation"
import { Flex, StartFlex, CenterFlex, Text, Button, IconFont } from "~components/El"
import { Tabs } from "~components/Tabs"
import { AuthLayout } from "~components/Layout"
import Email from "./components/email"
import Phone from "./components/phone"
import { AuthTipText } from "../components/auth-tip-text"

const Dotted = styled(CenterFlex)`
  width: 4px;
  height: 4px;
  margin-right: 10px;
  border-radius: 2px;
  background-color: ${({ theme }) => theme.colors.secondaryText};
`
const tabs: string[] = ["邮箱找回", "手机找回"]
const tips = [
  "验证码有效期为10分钟",
  "如果没有收到验证码，请检查垃圾邮件文件夹",
  "确保输入的邮箱是您注册时使用的",
]
const ForgetPasswword: React.FC = () => {
  const theme = useTheme()
  const navigation = useNavigation()
  const [tab, setTab] = useState("邮箱找回")
  const [email, setEmail] = useState("")
  const [phone, setPhone] = useState("")

  const onTabPress = (item: string) => {
    if (tab !== item) {
      setEmail("")
      setPhone("")
      setTab(item)
    }
  }

  const onVerifyCode = () => {
    const params: any = {}
    if (tab === "邮箱找回") {
      params.email = email
      params.type = "find_password"
    } else {
      params.phone = phone
      params.country_code = "+86"
      params.type = "find_password"
    }
    navigation.navigate("VerifyCode", { data: params })
  }

  return (
    <AuthLayout
      title="忘记密码"
      subtitle="输入邮箱，我们将发送重置密码的验证码"
    >
      <StartFlex flexDirection="column" width="100%" padding="12px 20px">
        <Tabs
          tabs={tabs}
          active={tab}
          onChange={(item) => onTabPress(item)}
        />
        {tab === "邮箱找回" && (
          <>
            <Email value={email} onChange={setEmail} />
          </>
        )}
        {tab === "手机找回" && (
          <>
            <Phone value={phone} onChange={setPhone} />
          </>
        )}

        <CenterFlex width="100%" mt="10px">
          <Button
            width="100%"
            height="44px"
            borderRadius="8px"
            bg={theme.colors.primary}
            onClick={onVerifyCode}
          >
            <Text color={theme.colors.textLight} fontSize={theme.fontSizes.lg} fontWeight="600">发送验证码</Text>
          </Button>
        </CenterFlex>
        <Flex
          flexDirection="column"
          width="100%"
          mt="10px"
          padding="10px 12px"
          borderRadius="8px"
          bg={theme.colors.background}
        >
          <Text color={theme.colors.danger} fontSize={theme.fontSizes.lg}>
            <IconFont name="wxts" size={16} color={theme.colors.danger} />&nbsp;&nbsp;温馨提示
          </Text>
          <Flex
            flexDirection="column"
            width="100%"
            mt="10px"
            pl="26px"
          >
            {tips.map((text, index) => (
              <StartFlex key={index} >
                <Dotted />
                <AuthTipText text={text} />
              </StartFlex>
            ))}
          </Flex>
        </Flex>
        <CenterFlex width="100%" mt="30px">
          <Button flexDirection="row" onClick={() => { navigation.navigate("Login") }}>
            <Text color={theme.colors.text} fontSize={theme.fontSizes.md}>想起密码了？</Text>
            <Text color={theme.colors.primaryText} fontSize={theme.fontSizes.md}>&nbsp;立即登录</Text>
          </Button>
        </CenterFlex>
      </StartFlex>
    </AuthLayout>
  )
}
export default observer(ForgetPasswword)
